
<mat-dialog-content>
    <div style="width: 25px;height: 25px;float: right;position: relative;cursor: pointer;"
    (click)="closeModal()">
    <i class="material-icons icon" style="font-size: 30px;color: #c80000">
        cancel
    </i>
</div>
    <form [formGroup]="overtimeForm">

        <div *ngIf="data.isNew && data.tabNo != 5">
            <div class="row" *ngIf="currentUser.hr">
                <div class="col-lg-12">
                    <div class="form-group">
                        <label class="radio-group-label" id="isParentExist">Başkası adına mı kayıt
                            oluşturulacak?</label>
                        <mat-radio-group class="horizontal-radio-group" aria-labelledby="isParentExist"
                            [(ngModel)]="isOvertimeForMe" [ngModelOptions]="{standalone: true}"
                            (change)="overtimeOwnerChange()">
                            <mat-radio-button class="overtimeforme-radio-button" value="1">Evet</mat-radio-button>
                            <mat-radio-button class="overtimeforme-radio-button" value="0"
                                [checked]="true">Hayır</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
            </div>

            <div class="row" *ngIf="isOvertimeForMe == '1'">
                <div class="col-lg-12">
                    <!-- kimin adina acilacak ise onu sec -->
                    <div class="form-group">
                        <mat-form-field class="overtime-form-field">
                            <input type="text" placeholder="Fazla Mesai açılacak çalışan seçiniz" aria-label="Number"
                                matInput [formControl]="employeeControl" [matAutocomplete]="auto">
                            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn2">
                                <!--<mat-option *ngFor="let employee of filteredEmployeeList | async" (onSelectionChange)="employeeChange($event)">-->
                                <mat-option *ngFor="let employee of filteredEmployeeList | async" [value]="employee">
                                    {{employee.fullName}}
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="data.tabNo == 5">
            <label class="radio-group-label"></label>
            <mat-radio-group class="horizontal-radio-group" [(ngModel)]="isCompleted"
                [ngModelOptions]="{standalone: true}">
                <mat-radio-button name="approve" class="overtimeforme-radio-button"
                    [value]="radioOnay">Onayla</mat-radio-button>
                <mat-radio-button name="reject" class="overtimeforme-radio-button"
                    [value]="radioRed">Reddet</mat-radio-button>
            </mat-radio-group>
        </div>

        <div class="row">
            <div class="col-lg-6">
                <div class="form-group">
                    <mat-form-field class="overtime-form-field">
                        <input matInput placeholder="Personel Ad Soyadı" style="width: 250px;"
                            [value]="personelFullname" readonly>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <mat-form-field class="overtime-form-field">
                        <input matInput placeholder="Departman" style="width: 250px;" [value]="departmentName" readonly>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-8">
                <div class="form-group">
                    <mat-form-field class="overtime-form-field">
                        <mat-label>Fazla Mesai Türü</mat-label>
                        <mat-select [(value)]="selectedOvertimeType" formControlName="overtimeType"
                            (selectionChange)="overtimeTypeChanged()">
                            <mat-option *ngFor="let overtimeType of overtimeTypeList" [value]="overtimeType">
                                {{overtimeType.description}}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="overtimeForm.controls['overtimeType'].hasError('required')">Fazla Mesai Türü
                            Seçiniz
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-lg-4">
                <mat-checkbox formControlName="isRestDay" id="isRestDay" aria-label="description">
                    Hafta tatili mi ?
                </mat-checkbox>
            </div>
        </div>

        <!--<div class="row" *ngIf="selectedOvertimeType != null && selectedOvertimeType.id == 22"> -->
        <!-- Mazaret izni seçildiği zaman -->
        <div class="row" *ngIf="selectedOvertimeType != null">
            <div class="col-lg-6">
                <div class="form-group">
                    <mat-form-field class="w-100">
                        <mat-label>Mesai Tarihi</mat-label>
                        <input readonly matInput [matDatepicker]="pickerStart" formControlName="overtimeDate"
                            placeholder="Mesai Tarihi" >
                        <mat-datepicker-toggle disabled="false" matSuffix [for]="pickerStart"></mat-datepicker-toggle>
                        <mat-datepicker #pickerStart></mat-datepicker>
                    </mat-form-field>
                    <mat-error
                        *ngIf="overtimeForm.controls['overtimeDate'].hasError('required') && overtimeForm.get('overtimeDate').touched">
                        Mesai tarihi seçiniz
                    </mat-error>
                </div>
            </div>

            <div class="col-lg-3">
                <div class="form-group">
                    <mat-form-field class="w-100">
                        <mat-label>Saat seçiniz</mat-label>
                        <mat-select [(value)]="selectedHourMinuteForStart" (selectionChange)="startHourMinuteChanged()">
                            <mat-option *ngFor="let hourMinute of hourMinuteListForStart" [value]="hourMinute">
                                {{hourMinute}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-lg-3">
                <div class="form-group">
                    <mat-form-field class="w-100">
                        <mat-label>Saat seçiniz</mat-label>
                        <mat-select [(value)]="selectedHourMinuteForEnd"  (selectionChange)="endHourMinuteChanged()">
                            <mat-option *ngFor="let hourMinute of hourMinuteListForEnd" [value]="hourMinute">
                                {{hourMinute}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12">
                <div class="form-group">
                    <mat-form-field class="overtime-form-field">
                        <mat-label>Şube </mat-label>
                        <mat-select [(value)]="selectedOvertimeBranch" formControlName="overtimeBranch">
                            <mat-option *ngFor="let overtimeBranch of overtimeBranchList" [value]="overtimeBranch">
                                {{overtimeBranch.description}}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="overtimeForm.controls['overtimeBranch'].hasError('required')">Şube Seçiniz
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <div class="form-group">
                    <mat-form-field class="overtime-form-field">
                        <mat-label>Proje</mat-label>
                        <mat-select [(value)]="selectedOvertimeProject" formControlName="overtimeProject"
                            (selectionChange)="overtimeProjectChanged()">
                            <mat-option *ngFor="let overtimeProject of overtimeProjectList" [value]="overtimeProject">
                                {{overtimeProject.description}}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="overtimeForm.controls['overtimeProject'].hasError('required')">Proje
                            Seçiniz
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <div class="form-group" *ngIf="selectedOvertimeProject?.attribute2=='Y'">
                    <mat-form-field class="overtime-form-field" *ngIf="selectedOvertimeProject?.attribute2=='Y'">
                        <mat-label>Kiracı</mat-label>
                        <mat-select [(value)]="selectedOvertimeTenant" formControlName="overtimeTenant">
                            <mat-option *ngFor="let overtimeTenant of overtimeTenantList" [value]="overtimeTenant">
                                {{overtimeTenant.description}}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="overtimeForm.controls['overtimeTenant'].hasError('required')">Kiracı
                            Seçiniz
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6">
                <div class="form-group">
                    <mat-form-field class="lookup-form-field" style="width: 100%;">
                        <input matInput formControlName="overtimeDuration" id="overtimeDuration" [value]="calculateWorkDuration()"
                            aria-describedby="overtimeDuration" placeholder="Mesai Süresi" readonly>
                            
                    </mat-form-field>
                    <mat-error *ngIf="invalidTimeRange">
                        Bitiş saati, başlangıç saatinden büyük olmalıdır.
                    </mat-error>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-6">
                <div class="form-group">
                    <mat-form-field class="lookup-form-field" style="width: 100%;">
                        <textarea style="height: 100px;resize: none;" matInput formControlName="description"
                            id="description" class="form-control" aria-describedby="description" placeholder="Açıklama"
                            maxlength="500"></textarea>
                    </mat-form-field>
                    <mat-error *ngIf="overtimeForm.get('description').value == ''">
                        Açıklama girilmelidir
                    </mat-error>
                </div>
            </div>
        </div>

        <div class="form-group">
            <input type="file" #myFile placeholder="Dosya yükle" (change)="fileProgress($event)">
            <div class="requiredFileOnClose" style="padding: 5px 4px; color: red"
                *ngIf="selectedOvertimeType != null && selectedOvertimeType.requiredFileOnClose != null && fileList.length === 0">
                Lütfen {{selectedOvertimeType.requiredFileOnClose}} Yükleyiniz</div>

            <div *ngIf="fileUploadProgress">
                <span style="font-weight: bold;">Yükleniyor:</span> {{ fileUploadProgress }}
            </div>
            <div style="margin-top: 5px">
                <button class="btn btn-light" [disabled]="!fileData" (click)="uploadFile()">Yükle</button>
            </div>
            <div style="margin-top: 5px" *ngFor="let file of fileList;let i = index;">
                <div class="filename-wrapper" *ngIf="!file.willBeDeleted">
                    <a style="width: 100px;max-width: 100px;">
                        {{file.fileName}}
                    </a>
                    <i class="material-icons icon" style="color: #c80000;margin-left: 5px;cursor: pointer"
                        (click)="deleteFile(i)">
                        delete
                    </i>
                </div>
            </div>
        </div>

        <div>
            <mat-checkbox formControlName="readAndAprroved" id="readAndAprroved" aria-label="description">
                Fazla Mesai kural ve şartlarını okudum, anladım.Bu formda belirtilen tarih ve <br/> saat aralığında mesai yaptığımı beyan ederim.
            </mat-checkbox>
        </div>

        <button type="submit" class="btn btn-primary" (click)="createOrUpdateOvertime()">{{submitButtonName}}</button>
        <!--<button type="submit" class="btn btn-primary" (click)="createOrUpdateovertime()">{{submitButtonName}}</button>-->
    </form>
</mat-dialog-content>


<!-- <ng-template #conditions>
    <div class="modal-header" style="height: 65px;">
        <h4 class="modal-title pull-left" style="font-size: 24px">Fazla Mesai Kural ve Şartları</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="conditionModalRef.hide()">
            <span aria-hidden="true" style="font-size: 35px;">&times;</span>
        </button>
    </div>
    <div class="modal-body" style="font-size: 13px;text-align: justify;overflow-y: scroll;">
        Görevlendirme yapılan veya izne ayrılan personel görev/izin esnasında, göreve/izne gidiş-dönüş esnasında
        iş sağlığı ve güvenliği kurallarına harfiyen uymakla yükümlüdür. Can ve mal güvenliği adına risk tespit
        ettiğinde
        durumu derhal yazılı olarak iş bu formu onaylayan birim yöneticisine bildirecektir. İş bu form onaylanmadan
        yerleşke dışına çıkacak personelin sorumluluğu kendisine aittir.

        <ul style="margin-left: -20px">
            <li> Talep edilen izin süresi hesabında ilgili giriş çıkış kayıtları esas alınacaktır.</li>
            <li>Vardiyalı çalışanlar için ilgili vardiya planı ek olarak yüklenmelidir. Beyan edilen vardiya düzenine
                göre çalışma günü olmayan gün sayısı hesaplanacaktır.</li>
            <li>Taşınma/görevlendirme/evlilik/vefat/doğum vb. izin türleri için gerekli ek dosyalar yüklenerek izin
                kaydı
                açılmalı veya İnsan Kaynakları birimine iletilmelidir.</li>
            <li>Yöneticiler için izin süresi boyunca başka bir “yönetici kullanıcı” vekil olarak seçilmelidir. Fazla
                Mesai süresi
                boyunca açılan izin talepleri vekil olarak seçilen yöneticiye atanacaktır.</li>
            <li>Kişisel verilerin işlenmesinde başta özel hayatın gizliliği olmak üzere kişilerin temel hak ve
                özgürlüklerinin
                korunmasını amaçlayan 7 Nisan 2016 tarihli ve 29677 Sayılı Resmî Gazete’de yayımlanan 6698 sayılı
                Kişisel Verilerin
                Korunması Kanunu (“KVKK” veya “Kanun”)’nun “Veri Sorumlusunun Aydınlatma Yükümlülüğü” başlıklı 10.
                maddesi ile
                10 Mart 2018 tarih ve 30356 sayılı Resmi Gazete’de yayımlanan Aydınlatma Yükümlülüğünün Yerine
                Getirilmesinde
                Uyulacak Usul ve Esaslar Hakkında Tebliğ uyarınca gerekli şartlar ve tedbirler AKILLI BİNALAR TESİS
                YÖNETİM A.Ş.
                tarafından yerine getirilmekle beraber işlenen kişisel verileriniz hakkında bilgilendirme metni internet
                sitemiz
                <a href="http://www.akillibinalar.com.tr" target="_blank">www.akillibinalar.com.tr</a> adresinde
                yayınlanmaktadır.
            </li>
        </ul>
    </div>
</ng-template> -->